<template>
  <div>
    <div class="card">
      <div class="flex">
        <el-form-item label="治疗日期" class="single">
          <el-date-picker v-model="formData.treatmentTime" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="就医者姓名" class="single">
          <el-input v-model.trim="formData.patientName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="formData.sex" clearable placeholder="请选择性别">
            <el-option v-for="(item, index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄" class="single">
          <el-input v-model.trim="formData.age" placeholder="请输入年龄"></el-input>
        </el-form-item>
        <el-form-item label="医生">
          <el-select @focus="focus(1)" :filter-method="doctorMatch" filterable remote clearable v-model="formData.doctorName" placeholder="选择医生">
            <el-option v-for="item in newList1" :key="item.id" :label="item.identityName" :value="item.identityName">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="主诉" class="double">
        <el-input v-model.trim="formData.chiefComplaint" style="width:95%;" placeholder="请输入主诉"></el-input>
      </el-form-item>
      <el-form-item label="现病史" class="double">
        <el-input v-model.trim="formData.latestMedicalHistory" style="width:95%;" placeholder="请输入现病史"></el-input>
      </el-form-item>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ['formData'],
  computed: {
    ...mapState(["sexey",]),
    ...mapGetters(["list1"]),
  },
  data() {
    return {
      newList1: [],
    }
  },
  methods: {
    focus(val) {
      if (val == 1) {
        this.newList1 = this.list1;
      }
    },

    doctorMatch(val) {
      this.newList1 = _g.paramMatch(this.doctorList, this.newList1, val, 'menuName')
    },
  }
}
</script>
<style scoped>
.card >>> .el-select .el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
}
.single >>> .el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.double >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
/* .card >>> .el-form-item__label {
  line-height: 30px;
} */
.card >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.child >>> .el-form-item {
  margin-bottom: 3px !important;
}
.card >>> .el-input__icon {
  line-height: 30px;
}
.card >>> .el-button i {
  margin: 0 !important;
}
.card >>> .el-button--mini {
  margin-top: 5px;
}
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
.flex {
  display: flex;
  flex-wrap: wrap;
}
</style>

